var React = require('react');

function Vacuum (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M576,320V448a64,64,0,0,1-64,64H446.22A110.73,110.73,0,0,0,352,321.61V160a32,32,0,0,1,32-32C490,128,576,214,576,320Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M368,352a80,80,0,1,0,80,80A80,80,0,0,0,368,352Zm0,96a16,16,0,1,1,16-16A16,16,0,0,1,368,448ZM640,128A128.14,128.14,0,0,0,512,0H301.61C241.64,0,189,42.56,176.44,101.19L102.12,448H48A48,48,0,0,0,0,496a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V464a16,16,0,0,0-16-16h-8.41L239,114.59A64.33,64.33,0,0,1,301.61,64H512a64,64,0,0,1,13.47,126.51h0a191.73,191.73,0,0,1,35.9,56c-.15-.37-.26-.77-.41-1.14C607.16,226.11,640,181.13,640,128Z","className":"fa-primary","key":2})]);
}

Vacuum.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Vacuum;

Vacuum.default = Vacuum;
